import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { translations } from "./translations";

const STORAGE_KEY = "uv_lang";
const DEFAULT_LANG = "en";

const I18nContext = createContext({
  lang: DEFAULT_LANG,
  t: translations[DEFAULT_LANG],
  setLang: () => {},
  toggleLang: () => {},
});

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(DEFAULT_LANG);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      if (saved === "en" || saved === "ms") {
        setLangState(saved);
        document.documentElement.lang = saved === "ms" ? "ms" : "en";
      }
    } catch (_e) {
      // ignore
    }
  }, []);

  const setLang = useCallback((next) => {
    if (next !== "en" && next !== "ms") return;
    setLangState(next);
    document.documentElement.lang = next === "ms" ? "ms" : "en";
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (_e) {
      // ignore
    }
  }, []);

  const toggleLang = useCallback(() => {
    setLang(lang === "en" ? "ms" : "en");
  }, [lang, setLang]);

  const value = useMemo(
    () => ({
      lang,
      t: translations[lang] || translations[DEFAULT_LANG],
      setLang,
      toggleLang,
    }),
    [lang, setLang, toggleLang]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
export const useT = () => useContext(I18nContext).t;

export default I18nContext;
